import { render, staticRenderFns } from "./DaterWeek.vue?vue&type=template&id=9ddb699a&"
import script from "./DaterWeek.vue?vue&type=script&lang=js&"
export * from "./DaterWeek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports